export default __webpack_public_path__ + "static/media/dots.793b8be8.svg";